import React from 'react';
import { Frown } from "lucide-react";

export default function a() {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen text-gray-700">
            <div className="text-[120px] mb-4">
                <Frown size={250} />
            </div>
            <h1 className="text-6xl font-semibold mb-2">404</h1>

            <h2 className="text-2xl font-medium mb-4">Page not found</h2>

            <p className="text-gray-500 max-w-md text-center px-4">
                The page you are looking for doesn’t exist or another error occurred.
            </p>
        </div>
    )
}
